// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"1fd05948","451":"748730c0","544":"3194a168"}[chunkId] + ".chunk.js";
};